<template>
    <div
        @click="clicked"
        :class="computedClass"
        :style="{ left, top, width, height, background }"
        style="font-size: 36.6px; font-family: sans-serif;position:absolute"
    ></div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import { backgroundUtils } from "@/modules/invoices/domain/PDFTextTagUtils";

export default {
    name: "PDFTextTag",
    props: {
        totalWidth: Number,
        totalHeight: Number,
        index: Number,
        annotation: Object,
    },
    data() {
        return {
            colors:{
                'inv_number': 'red',
                'supplier': 'orange',
                'vat_supplier': 'orange',
                'customer': 'orange',
                'vat_customer': 'orange',
                'total_amount': 'pink',
                'invoice_date': 'indigo',
                'due_date': 'lime',
                'payment_method': 'teal',
                'retention_type': 'cyan',
                'retention_amount': 'light-green',
                'third_concept': 'crimson',
                'other_amounts': 'light-blue',
                'subsidized_amount': 'light-blue',
                'amount_exempt': 'deep-purple',
                'amount_to_pay': 'amber',
                'delivery_note_number': '#B0B0B0',
                'background': '#CCCCCC'
            }
        };
    },
    methods:{
        clicked() {
            this.emitTextClicked(this.index)
            
            if (this.selected) {
                this.setSelectedText({ index: null });
            } else {
                this.setSelectedText({ index: this.index });
            }
        },
        ...mapActions({
            setSelectedText: "documents/setSelectedText",
            emitTextClicked: "text_tags/emitTextClicked",
        })
    },
    computed:{
        left() {
            return this.annotation.x1*this.totalWidth+'px';
        },
        top() {
            if(this.annotation.direction && this.annotation.direction=='vertical')
                return (this.annotation.y2-this.annotation.page)*this.totalHeight+'px';
            return (this.annotation.y1-this.annotation.page)*this.totalHeight+'px';
        },
        width() {
            return this.annotation.w*this.totalWidth+'px';
        },
        height() {
            return this.annotation.h*this.totalHeight+'px';
        },
        isPageFocused() {
            return this.annotation.page == this.$store.state.currentPage-1;
        },
        background() {
            return backgroundUtils(this);
        },
        selected() {
          return this.selectedText == this.index
        },
        computedClass() {
            return this.selected ? "box-selected":"box"
        },
        ...mapGetters({
            selectedText: "documents/selectedText",
            annotationLayer: 'documents/annotationLayer',
        })
    }
}
</script>

<style>
    .box {
        opacity: 0.3;
    }
    .box-selected {
        opacity: 0.8;
    }
    .box:hover{
        opacity: 0.6;
    }
</style>
